export default {
  "common": {
    "all": "全部",
    "cancel": "取消",
    "userAgreement": "用户协议",
    "close": "关闭",
    "submit": "提交",
    "submitting": "提交中...",
    "report": "举报",
    "loading": "加载中...",
    "noMore": "没有更多内容了",
    "search": "搜索",
    "today": "今天",
    "collapse": "收起",
    "retryLater": "请稍后重试",
    "retry": "重试",
    "reset": "重置",
    "confirm": "确认",
    "tips": "提示",
    "continue": "继续",
    "notAvailableYet": "暂未开放",
    "friendlyReminder": "温馨提示",
    "finish": "完成",
    "noData": "暂无相关数据"
  },
  "tab": {
    "home": "首页",
    "card": "卡片",
    "mine": "我的"
  },
  "auth": {
    "loginTitle": "一站式Web3支付钱包",
    "loginSubtitle": "一卡连接资产与消费，轻松开启全球支付体验",
    "createWallet": "创建钱包",
    "importWallet": "我已有钱包",
    "choiceOneWay": "选择一种方式，快速开启安全的数字资产之旅",
    "iHaveWallet": "我已有钱包",
    "choiceOneWay2": "选择一种登录方式，快速开启安全的数字资产之旅",
    "createUseEmail": "使用邮箱创建",
    "createUseRemWord": "创建助记词钱包",
    "loginUseEmail": "使用邮箱登录",
    "loginByReWord": "私钥 / 助记词 导入",
    "validByEmail": "通过邮箱快速验证，简单便捷",
    "validByReWord": "由助记词完全掌握，安全且去中心化",
    "validByReWord2": "使用助记词/私钥/钱包地址导入",
    "emailLoginRegister": "邮箱登录/注册",
    "inviteRegisterTitleStart": "一触即付，",
    "inviteRegisterTitleEnd": "轻松完成",
    "inviteRegisterStartRewards": "开启奖励",
    "inviteRegisterWelcome": "欢迎加入 WinPay！",
    "agreePrefix": "继续使用，代表你同意 WinPay Wallet 的",
    "privacyPolicy": "隐私政策",
    "and": "和",
    "userAgreement": "用户协议",
    "agreementMessage": "请先阅读用户隐私协议，点击继续表明您同意 WinPay Wallet 的隐私政策和用户协议",
    "agreementConfirm": "已阅读并同意",
    "addEmailAddress": "添加邮箱地址",
    "inputEmailAddress": "输入邮箱地址",
    "emailAccountTip": "此邮箱地址将成为您的登录账号，也是您访问我们提供的全部服务的关键。",
    "emailAddress": "邮箱地址",
    "email": "邮箱",
    "emailLogin": "邮箱登录",
    "enterEmail": "请输入邮箱",
    "enterEmailAddress": "请输入邮箱地址",
    "register": "注册",
    "login": "登录",
    "enterVerificationCode": "输入验证码",
    "codeSentTo": "验证码已发送至 ",
    "codeSentToEmail": "验证码已发送至您的邮箱：",
    "codeValid": "，有效期10分钟",
    "emailCode": "邮箱验证码",
    "enterEmailCode": "请输入邮箱验证码",
    "getCode": "获取验证码",
    "resend": "重新发送",
    "codeSent": "已发送验证码",
    "codeSentValid": "*验证码已发送，10 分钟内有效",
    "cannotReceiveCode": "收不到验证码？",
    "checkSpamFolder": "请检查垃圾邮件文件夹",
    "codeHelpTitle": "收不到验证码？",
    "codeHelpIntro": "验证码通常会在1分钟内送达，如果您还没收到：",
    "codeHelpEmailTitle": "检查邮箱地址是否正确",
    "codeHelpEmailDesc": "请确认验证码发送到了您预期的邮箱地址，一个小小的拼写错误，是最常见的未送达原因。",
    "codeHelpSpamTitle": "检查垃圾邮件文件夹",
    "codeHelpSpamDesc": "验证邮件有时会将我们的邮件标记为“垃圾邮件”，请您确认并更换为“非垃圾邮件”类型，有助于后续验证码送达您的收件箱。",
    "codeHelpResendTitle": "再次申请新验证码",
    "codeHelpResendDesc": "请务必使用最新的验证码，因为旧验证码会失效。",
    "verify": "验证",
    "inputPassword": "输入密码",
    "setWalletPassword": "设置支付密码",
    "walletPasswordTip": "设置密码用于管理你的钱包。此密码无法恢复，如果你忘记密码，可进入我的主页面-安全设置-找回密码，或者使用邮箱登录重新进入，重设您的支付密码!",
    "setPasswordForTransaction": "请设置钱包密码，主要用于交易验证。",
    "strongPassword": "请输入一个强密码",
    "enterPasswordPlaceholder": "请输入密码",
    "enterPassword": "请输入",
    "confirmPassword": "请再次输入密码",
    "passwordTooShort": "*密码太短，至少需要8个字符。",
    "passwordWeak": "密码较弱",
    "passwordMedium": "密码中等",
    "passwordStrong": "密码较强",
    "passwordMismatch": "两次密码不一致",
    "passwordError": "密码错误",
    "bindEmail": "绑定邮箱",
    "bindEmailIntro": "为了您的资金安全，请绑定邮箱",
    "emailForRecovery": "用于找回密码",
    "emailRequired": "邮箱不能为空",
    "codeRequired": "验证码不能为空",
    "invitationCode": "邀请码",
    "enterInvitationCode": "请输入邀请码（选填）",
    "verificationFailed": "校验失败",
    "walletReady": "钱包已创建",
    "walletCreatedSuccess": "欢迎回来!",
    "walletExploreTip": "WinPay 全功能已为您开启",
    "firstExploreCreateTitle": "钱包创建成功!",
    "firstExploreRegisterTitle": "登录成功!",
    "firstExploreLoginTitle": "欢迎回来！",
    "firstExploreImportTitle": "钱包导入成功！",
    "firstExploreCreateSubtitle": "现在可以探索公链的加密钱包",
    "firstExploreDefaultSubtitle": "WinPay 全功能已为您开启",
    "startExplore": "开始探索",
    "importTitle": "输入助记词或私钥",
    "importWalletTip": "助记词之间用空格隔开。支持任意钱包的助记词或私钥导入。",
    "importPlaceholder": "输入助记词或私钥",
    "importInvalid": "输入有误",
    "importTip1": "WinPay Wallet 不会记录您的助记词或私钥，权限用户自管，资产由你掌控。",
    "importTip2": "请确保周围没有其他人或摄像头。",
    "importTip3": "建议您手写输入或扫码导入您的助记词或私钥。",
    "continue": "继续",
    "backupWarnTitle": "备份前请谨记！",
    "backupTipWrite": "建议手写抄录",
    "backupTipNoCopy": "请勿复制保存",
    "backupTipNoScreenshot": "请勿截屏保存",
    "backupWarn1Title": "助记词相当于您的钱包密码",
    "backupWarn1Desc": "获得助记词等于获得资产所有权，一旦泄露资产将不再安全",
    "backupWarn2Title": "请手写抄录或存储于冷钱包等离线设备中",
    "backupWarn2Desc": "若复制或截屏保存，助记词有可能泄露",
    "backupWarn3Title": "将助记词存放在安全的地方",
    "backupWarn3Desc": "一旦丢失资产将无法找回",
    "backupWarnCheck": "助记词由您个人保管，请务必备份，一旦丢失资产将无法找回！",
    "backupMnemonic": "备份助记词",
    "mnemonicDesc": "助记词相当于您的钱包密码，获得助记词等同于获得钱包资产所有权，一旦泄露资产将不再安全，请妥善备份保管助记词。",
    "verifyMnemonicTitle": "验证助记词",
    "verifyMnemonicTip": "请按顺序验证助记词",
    "ordinalNumber": "第{number}个",
    "mnemonicCheckFailed": "助记词验证失败",
    "mnemonicCheckSuccess": "助记词验证成功",
    "mnemonicUnavailable": "当前钱包暂无助记词备份信息",
    "verifyWalletPassword": "请输入支付密码",
    "forgotPasswordRecovery": "忘记密码？找回密码",
    "resetPaymentPassword": "找回密码",
    "resetPaymentPasswordTip": "请通过已绑定邮箱验证后重设支付密码",
    "changePassword": "修改密码",
    "currentPassword": "当前密码",
    "enterCurrentPassword": "输入当前密码",
    "setPassword": "设定新密码",
    "pleaseSetNewPasswordMin8": "请设定新密码，新密码不低于8位",
    "newPassword": "新密码",
    "setNewPasswordMin8": "请设置新密码，至少 8 位",
    "enterNewPassword": "输入新密码",
    "confirmNewPassword": "确定新密码",
    "setNewPasswordAgain": "请再次确认新设置的密码",
    "currentPasswordIncorrect": "当前密码不正确",
    "newPasswordSameAsOld": "新密码不能与旧密码相同",
    "passwordsNotMatch": "两次新密码不匹配",
    "passwordOnlySavedLocally1": "我知晓密码仅在本机保存，",
    "passwordOnlySavedLocally2": "忘记后无法找回",
    "noBoundEmailRecover": "您尚未绑定邮箱，无法找回密码",
    "goBindEmail": "去绑定邮箱",
    "boundEmail": "验证邮箱",
    "changeSuccess": "修改成功",
    "bindEmailTip": "请先绑定邮箱，才可进行找回密码操作",
    "bindEmailTip2": "为保障账户安全，找回密码前请先绑定邮箱，以便接收验证消息。",
    "bindEmailTip3": "请先绑定邮箱",
    "noBindEmail": "暂不绑定",
    "canUseWallet": "恭喜您，可以使用钱包啦！",
    "successfullyProtected": "你已经成功地保护了你的钱包。记住保护你的助记词安全，丢失后将无法找回！你可以随时在设置→钱包管理→选择钱包→导出助记词进行备份",
    "startUseApp": "开始使用 WinPay Wallet",
    "next": "下一步"
  },
  "home": {
    "title": "首页",
    "totalAssets": "总资产估值",
    "receive": "收款",
    "scan": "扫一扫",
    "transfer": "转账",
    "topup": "充值",
    "withdraw": "提现",
    "bill": "资金流水",
    "invite": "邀请好友",
    "invitCode": "邀请码二维码",
    "more": "更多",
    "recent": "常用功能",
    "community": "社区动态",
    "token": "代币",
    "turnover": "流水",
    "nft": "NFT",
    "accountAssets": "账户资产",
    "cardAssets": "卡内资产",
    "cardWallet": "卡片",
    "backup": "去备份",
    "winpayCardPayment": "WinPay 虚拟卡 + 实体卡双重支付加持",
    "applyExclusiveCard": "申请专属卡",
    "nodeFast": "节点正常",
    "nodeSlow": "节点较慢",
    "nodeBad": "节点异常",
    "node": "节点",
    "viewAccount": "选择账户",
    "selectAccount": "选择账户",
    "selectNode": "选择节点",
    "blockHeightExplain": "节点延迟越低、区块高度越新，通常代表节点连接状态越好。",
    "recommendNode": "推荐节点",
    "blockHeight": "区块高度",
    "currentAccountNotSupport": "当前账户暂不支持该网络",
    "noData": "暂无数据",
    "actionTodo": "暂未开放",
    "cardTailNo": "尾号",
    "tradeSuccess": "交易成功",
    "tradeFailed": "交易失败",
    "kycRetryRequired": "您的kyc认证失败，需要再次认证！",
    "viewNow": "立即查看"
  },
  "wallet": {
    "chooseCoin": "选择其他币种",
    "chooseNetwork": "选择网络",
    "copyAddress": "复制地址",
    "copySuccess": "复制成功",
    "copyFailed": "复制失败",
    "saveSuccess": "保存成功",
    "saveFailed": "保存失败",
    "depositAddress": "充值地址",
    "topupNotes": "注意事项：",
    "topupNote1Prefix": "1.充值金额以",
    "topupNote1Highlight1": "“实际到账”",
    "topupNote1Middle": "为准,不同平台的",
    "topupNote1Highlight2": "“实际到账”",
    "topupNote1Suffix": "是扣除不同平台手续费(由转出的平台收取)之后的金额",
    "topupNote2": "2.请勿向上述地址充值任何非USDT资产，否则资产将不可找回",
    "topupNote3": "3.您充值至上述地址后,需要整个网络节点的确认,60次网络确认后到账,910次网络确认后可提币",
    "withdrawAddress": "提现地址",
    "enterWithdrawAddress": "请输入提现地址",
    "withdrawAmount": "提现数量",
    "withdrawAmountLabel": "数量",
    "maxAmountLabel": "最大金额",
    "available": "可用",
    "enterAmount": "请输入数量",
    "enterWithdrawAmount": "请输入提现金额",
    "all": "全部",
    "fee": "手续费",
    "received": "预计到账",
    "submitWithdraw": "提交提现申请",
    "withdrawNotes": "注意事项：",
    "withdrawNote1Prefix": "1．最小提币数量为 ",
    "withdrawNote2": "2．请务必保证提币地址的准确性，否则资产将无法找回",
    "withdrawNote3Prefix": "3．通过审核后",
    "withdrawNote3Suffix": "小时到账，网络原因可能有延迟",
    "withdrawNote4": "4．如长时间未到账，请联系客服核查",
    "withdrawUnavailable": "提币暂未开放",
    "withdrawConfirm": "确认提交提现吗？",
    "withdrawSuccess": "提币申请提交成功，请等待管理员审核",
    "billTitle": "资金流水",
    "billDetailTitle": "详情",
    "noBill": "暂无还没有数据",
    "noBillDetail": "暂无相关数据",
    "assetType": "类型",
    "recordType": "流水类型",
    "billTimeLabel": "时间",
    "choosePricingFiat": "选择计价法币",
    "hotFeatures": "热门功能",
    "moreFeatures": "更多功能",
    "walletFeatures": "热门功能",
    "cardFeatures": "卡片功能",
    "otherFeatures": "其他功能",
    "payment": "收款",
    "scanCode": "扫一扫",
    "failed": "失败",
    "walletBackup": "钱包备份",
    "openCard": "立即开卡",
    "physicalCard": "实体卡功能",
    "physicalUnavailable": "本次实体卡功能暂未开放，敬请期待！",
    "activateCard": "激活实体卡",
    "physicalTransfer": "实体卡转账",
    "fundTransfer": "划转",
    "fundTransferUnavailable": "功能暂未开放，敬请期待！",
    "receiveAddress": "收款地址",
    "saveCollectionCode": "保存收款码",
    "transferInProperty": "仅可向 {network} 转入资产",
    "receiveTips": "收款提示",
    "receiveTip1": "请确认转入资产与当前网络一致。",
    "receiveTip2": "转入错误网络或错误币种可能导致资产无法找回。",
    "openCamera": "打开摄像头",
    "closeCamera": "关闭摄像头",
    "pasteScanResult": "粘贴或输入扫码结果",
    "scanResult": "扫码结果",
    "cameraUnavailable": "当前浏览器无法打开摄像头",
    "cameraPermissionDenied": "浏览器未允许访问摄像头，请先开启相机权限",
    "cameraPermissionHint": "如未弹出授权框，请检查浏览器站点权限里的“相机”是否已允许。",
    "cameraNotFound": "未检测到可用摄像头设备",
    "cameraInUse": "摄像头正在被其他应用占用，请关闭后重试",
    "cameraConstraintFailed": "当前设备不支持所请求的摄像头模式，已自动回退后仍无法打开",
    "cameraSecureContextRequired": "当前页面环境不支持调用摄像头，请在安全浏览器环境中打开",
    "cameraSecureContextHint": "安卓浏览器里，网页调用摄像头通常要求 HTTPS 或 localhost。使用局域网 http 地址时，往往不会直接弹出相机权限。",
    "cameraGuideTitle": "无法打开相机",
    "iosCameraGuideTitle": "iPhone 相机说明",
    "androidCameraGuideTitle": "安卓相机说明",
    "cameraPermissionGuide": "1. 在 iPhone Safari 中点击地址栏左侧的“aA”或页面菜单。<br/>2. 打开“网站设置”，将“摄像头”改为“允许”。<br/>3. 返回当前页面并刷新，再重新点击扫码。<br/>4. 如果之前点过“不允许”，也可以去 iPhone“设置 - Safari浏览器”里检查相机权限。",
    "cameraSecureGuide": "当前页面必须在安全环境下才能调用相机。<br/>1. 请确认你打开的是正式域名或安全链接。<br/>2. 返回页面刷新后再重试。<br/>3. 如果仍无效，请改用系统浏览器重新打开。",
    "cameraUnavailableGuide": "1. 请先确认 iPhone 系统相机可正常使用。<br/>2. 在 Safari 中检查当前网站的“摄像头”权限是否已允许。<br/>3. 关闭其他正在占用相机的应用后重试。<br/>4. 如果仍无法打开，请刷新页面或重新进入后再试。",
    "iosCameraPermissionGuide": "1. 在 iPhone Safari 中点击地址栏左侧的“aA”或页面菜单。<br/>2. 打开“网站设置”，将“摄像头”改为“允许”。<br/>3. 返回当前页面并刷新，再重新点击扫码。<br/>4. 如果之前点过“不允许”，也可以去 iPhone“设置 - Safari浏览器”里检查相机权限。",
    "iosCameraSecureGuide": "当前页面必须在安全环境下才能调用相机。<br/>1. 请确认你打开的是正式域名或安全链接。<br/>2. 返回页面刷新后再重试。<br/>3. 如果仍无效，请改用系统浏览器重新打开。",
    "iosCameraUnavailableGuide": "1. 请先确认 iPhone 系统相机可正常使用。<br/>2. 在 Safari 中检查当前网站的“摄像头”权限是否已允许。<br/>3. 关闭其他正在占用相机的应用后重试。<br/>4. 如果仍无法打开，请刷新页面或重新进入后再试。",
    "androidCameraPermissionGuide": "1. 请先在安卓浏览器地址栏或页面设置中查看“网站设置/权限设置”。<br/>2. 将当前网站的“相机”权限改为“允许”。<br/>3. 如果系统弹出过相机权限并被拒绝，请到“手机设置 - 应用 - 浏览器 - 权限”里开启相机权限。<br/>4. 返回页面刷新后，再重新点击扫码。",
    "androidCameraSecureGuide": "当前安卓浏览器通常要求安全环境才能调用相机。<br/>1. 请确认当前页面使用的是正式域名或 HTTPS 链接。<br/>2. 如果你打开的是局域网地址，很多安卓浏览器不会弹出相机权限。<br/>3. 请切换到正式地址后刷新页面再试。",
    "androidCameraUnavailableGuide": "1. 请先确认手机系统相机可以正常打开。<br/>2. 检查浏览器和系统是否都已允许相机权限。<br/>3. 关闭其他占用相机的应用后重试。<br/>4. 如果仍无法打开，请刷新页面或改用系统浏览器再试。",
    "androidScanGuideTitle": "安卓扫码说明",
    "androidScanGuide": "当前安卓浏览器已打开相机，但不支持本页使用的实时扫码能力。<br/>1. 建议优先使用系统浏览器或最新版 Chrome。<br/>2. 确认当前网站相机权限已允许。<br/>3. 刷新页面后重试，如果仍无效，请换支持网页扫码的浏览器。",
    "safariScanGuideTitle": "Safari 扫码说明",
    "safariScanGuide": "当前 iPhone Safari 已打开相机，但不支持本页使用的实时扫码能力。<br/>1. 先确认当前网站的“摄像头”权限已允许。<br/>2. 刷新页面后再重试一次。<br/>3. 如果仍无法识别，请改用支持网页实时扫码的浏览器或在其他入口完成扫码。",
    "scanNotSupportedGuide": "当前浏览器不支持本页使用的实时扫码能力。<br/>1. 请先确认当前网站已获得相机权限。<br/>2. 刷新页面后再重试一次。<br/>3. 如果仍无法识别，请改用系统浏览器或其他支持网页扫码的浏览器。",
    "scanNotSupported": "当前浏览器不支持实时扫码，请使用系统浏览器重试",
    "scanSuccess": "识别成功",
    "transferRecord": "转账记录",
    "directTransfer": "直接转账",
    "addressBookTransfer": "地址本转账",
    "scanTransfer": "扫码转账",
    "enterOrPasteAddress": "请输入或粘贴地址",
    "transferAmount": "转账金额",
    "transferHistory": "转账历史",
    "noTransferRecord": "暂无转账记录",
    "transferConfirm": "确认提交转账吗？",
    "addToken": "添加代币",
    "addNft": "添加NFT",
    "nftDetail": "NFT详情",
    "nftAssets": "资产",
    "nftAssetView": "NFT",
    "nftSendTitle": "发送NFT",
    "nftSendAsset": "发送资产",
    "sendNft": "发送",
    "removeNft": "删除",
    "invalidAddress": "请输入正确地址",
    "nftTransferUnsupported": "当前网络暂不支持 NFT 转账",
    "nftSendSuccess": "发送成功",
    "hotToken": "热门代币",
    "hotNft": "热门NFT",
    "customToken": "自定义代币",
    "customNft": "自定义NFT",
    "enterContractAddressSearch": "输入合约地址搜索",
    "tokenAddress": "代币地址",
    "nftAddress": "NFT地址",
    "enterTokenAddress": "请输入代币地址",
    "enterNftAddress": "请输入NFT合约",
    "tokenSymbol": "代币符号",
    "enterTokenSymbol": "请输入代币符号",
    "decimalPlaces": "小数位",
    "tokenAdded": "代币已添加",
    "addSuccess": "添加成功",
    "tokenDetail": "Token 详情",
    "propertyBalance": "资产余额",
    "transferIn": "转入",
    "transferOut": "转出",
    "transferInAddress": "转入地址",
    "transferOutAddress": "转出地址",
    "transactionId": "交易 ID",
    "blockchainBrowser": "区块链浏览器",
    "network": "网络",
    "pending": "处理中",
    "inTransaction": "交易中",
    "finish": "完成",
    "signTodo": "签名流程迁移中",
    "exportMnemonic": "导出助记词",
    "exportPrivateKey": "导出私钥",
    "sensitiveExportLabel": "需要完成身份验证后查看",
    "securityReminder": "安全提醒",
    "backupTip1": "助记词和私钥代表资产所有权，请离线妥善保管。",
    "backupTip2": "不要截图、录屏或通过聊天工具发送给任何人。",
    "backupTip3": "WinPay 不会保存你的助记词或私钥。",
    "backupSensitiveConfirm": "请确认周围环境安全后再继续。",
    "sensitiveExportTodo": "敏感导出流程迁移中",
    "privateKeyUnavailable": "当前钱包暂无私钥导出信息",
    "specialReminder": "特别提醒",
    "safetyReminder": "安全提醒",
    "privateCarefulExport": "导出私钥后请务必离线妥善保管，一旦泄露将可能造成资产丢失。",
    "clickShowPrivateKeyQr": "点击展示私钥二维码",
    "plaintextPrivateKey": "明文私钥",
    "copyPrivateKey": "复制私钥",
    "copyPrivateKeyAfter": "复制私钥后，务必对私钥进行妥善保管，否则会造成资产丢失。",
    "copyMnemonicAfter1": "复制助记词后，",
    "copyMnemonicAfter2": "不打开其他应用",
    "copyMnemonicAfter3": "避免被读取粘贴板",
    "notPasteMnemonic1": "不在",
    "notPasteMnemonic2": "任何连网的应用中进行粘贴，",
    "notPasteMnemonic3": "不用",
    "notPasteMnemonic4": "任何网盘、聊天工具进行备份",
    "notShareMnemonic1": "不将助记词分享给任何人，请注意，",
    "notShareMnemonic2": "我们永远不会向您索要助记词",
    "winpayCard": "WinPay Card",
    "openCardTitle": "申请开卡",
    "openCardDesc": "连接账户资产与全球支付场景",
    "openCardProcess": "开卡流程",
    "openCardStep1": "KYC 认证",
    "openCardStep2": "选择卡片",
    "openCardStep3": "完成开通",
    "cardSecure": "安全",
    "cardSecureDesc": "账户风控保护",
    "cardGlobal": "全球",
    "cardGlobalDesc": "多场景支付",
    "cardAsset": "资产",
    "cardAssetDesc": "余额统一管理",
    "openCardNow": "申请开卡",
    "cardKycTodo": "开卡 KYC 流程迁移中",
    "activatePhysicalCard": "激活实体卡",
    "activatePhysicalCardEntry": "激活实体卡",
    "activatePhysicalDesc": "收到实体卡后输入卡号和激活码完成激活",
    "cardNumber": "卡号",
    "enterCardNumber": "请输入卡号",
    "activeCode": "激活码",
    "enterActiveCode": "请输入激活码",
    "emailCode": "邮箱验证码",
    "enterEmailCode": "请输入邮箱验证码",
    "sendCode": "发送验证码",
    "activateNow": "立即激活",
    "activateTip1": "请在收到实体卡后再进行激活。",
    "activateTip2": "激活前请核对卡号、邮箱验证码和激活码。",
    "cardApiTodo": "卡片接口迁移中",
    "completeCardActiveForm": "请完善激活信息",
    "activateSuccess": "激活成功",
    "submitSuccess": "提交成功",
    "physicalTransferDesc": "实体卡之间的余额划转",
    "fromCard": "转出卡片",
    "selectCard": "请选择",
    "toCard": "转入卡片",
    "enterTargetCard": "请输入转入卡号",
    "remark": "备注",
    "optionalRemark": "选填",
    "completePhysicalTransferForm": "请完善转账信息",
    "transferFrom": "从",
    "transferTo": "到",
    "fundingAccount": "资金账户",
    "exchangeCoin": "兑换币种",
    "availableBalance": "可用余额",
    "transferInAmount": "转入金额",
    "transferOutAmount": "转出金额",
    "withdrawFeeLabel": "提现手续费"
  },
  "invite": {
    "title": "邀请好友",
    "inviteNow": "立即邀请",
    "share": "分享",
    "claim": "领取",
    "claimSuccess": "领取成功",
    "pendingClaim": "待领取",
    "claimableAmount": "可领取（USDT）",
    "claimed": "已领取",
    "expired": "已过期",
    "copyUrl": "复制链接",
    "saveQrCode": "保存二维码",
    "saveImage": "保存",
    "posterTitle": "一张卡 · 轻松全球支付",
    "posterTagline": "全球支付 · 一站式钱包",
    "pointsRules": "邀请规则",
    "referralStepsTitle": "分享邀请·流程步骤",
    "pointsRulesComingSoon": "积分奖励规则即将开放，敬请期待！",
    "heroTitle": "邀请开卡·奖励计划",
    "hero1": "推荐并赚取最多",
    "hero2": "60%",
    "hero3": "佣金",
    "heroDesc": "查看活动规则，开启邀请奖励",
    "partner": "合作伙伴",
    "partnerPromotion": "成为 WinPay 合作伙伴，专享推广高额收益",
    "partnerJoinNow": "立即加入",
    "coursePromotionTitle": "分享邀请·流程步骤",
    "purchaseCardToInvite": "购卡后开启邀请",
    "purchaseCardToInviteDesc": "您已完成身份认证，购买虚拟卡和实体卡后，即可获取专属邀请码与邀请链接，开启邀请奖励。",
    "unlockInviteTitle": "解锁邀请码与邀请链接条件：",
    "unlockInviteDesc": "任意购卡后，即可获取专属邀请码与邀请链接",
    "purchaseCardToInviteLater": "稍后再说",
    "purchaseCardToInviteNow": "立即购卡",
    "kycPurchaseCardDesc": "请先完成身份验证后购买虚拟卡、实体卡即可解锁此功能",
    "coursePromotionDesc": "点击查看邀请步骤，开启邀请奖励",
    "cardOpeningCommission": "邀请好友开卡返佣",
    "cardOpeningCommissionShort": "开卡返佣",
    "spendingCommission": "消费返佣",
    "commissionRefundDeduction": "返佣退款扣除",
    "reservedReward": "预留",
    "courseCommission": "开卡二级返佣",
    "globalDirectorCourseCommission": "全球唯一董事开卡二级返佣",
    "globalDirectorCardOpeningCommission": "全球唯一董事开卡返佣",
    "teamBonusPoolCardOpeningCommission": "团队奖金池开卡返佣",
    "teamBonusPoolCourseCommission": "团队奖金池开卡二级返佣",
    "globalDirectorTeamCardOpeningCommission": "全球唯一董事团队开卡返佣",
    "globalDirectorTeamCourseCommission": "全球唯一董事团队开卡二级返佣",
    "inviteFriendCardOpeningCommission": "邀请好友开卡返佣",
    "invitationCommission": "邀请返佣",
    "purchaseCommission": "购卡返佣",
    "consumptionCommission": "二级返佣",
    "friendCourseCommission": "好友开卡二级返佣",
    "inviteFriendCourseCommission": "邀请好友开卡二级返佣",
    "monthlyCommission": "月度返佣",
    "monthlyBonusPoolCommission": "团队奖金池返佣",
    "globalDirectorExclusiveCommission": "全球唯一董事专属返佣",
    "globalDirectorCardOpeningReward": "全球唯一董事开卡奖励",
    "monthlyCommissionTitle": "团队返佣",
    "monthlyCommissionIntro": "累计有效直推开卡 ≥ 5 人，即可获得 V3 团队奖励资格。",
    "monthlyCommissionTip1": "开卡返佣结算",
    "monthlyCommissionTip1Desc": "进入V3后，邀请好友完成有效开卡获得奖励。",
    "monthlyCommissionTip2": "等级分配奖励",
    "monthlyCommissionTip2Desc": "半月结算，根据有效直推人数确定对应T档。",
    "monthlyCommissionTip3": "团队奖励说明",
    "monthlyCommissionTip3Desc": "好友完成有效购课后，将为半月团队奖励池贡献奖励额度。",
    "monthlyCommissionTip4": "团队奖励结算",
    "monthlyCommissionTip4Desc": "半月结算,具体金额以系统最终结算结果为准。",
    "consumptionRefund": "邀请好友开卡返佣",
    "friendConsumptionRewardRefund": "好友消费返佣退款",
    "rewardRecordCardOpeningTitle": "[好友-{friendName}] 开卡返佣",
    "rewardRecordConsumptionTitle": "[{friendName}] 消费返佣",
    "rewardRecordRefundTitle": "[{friendName}] 消费退款",
    "rewardRecordCourseCommissionTitle": "[好友-{friendName}] 开卡二级返佣",
    "rewardRecordFriendCourseCommissionTitle": "邀请 [{friendName}] 好友开卡二级返佣",
    "rewardRecordMonthlyCommissionTitle": "[{friendName}] 月度返佣",
    "rewardRecordMonthlyBonusPoolTitle": "[{friendName}] 月度奖金池返佣",
    "rewardRecordRegistrationTitle": "邀请 [{friendName}] 注册",
    "invitationTotal": "有效邀请",
    "notUnlocked": "暂未解锁",
    "purchaseCommissionTitle": "购卡返佣",
    "purchaseCommissionIntro": "邀请好友成功开通WinPay卡,即可获得开卡佣金奖励。",
    "purchaseCommissionTip1": "等级越高，返佣比例越高，",
    "purchaseCommissionTip1Desc": "邀请更多好友开卡，满足条件后可进入团队奖金池。",
    "purchaseCommissionTip2": "虚拟卡与实体卡均享受同等返佣",
    "purchaseCommissionTip2Desc": "开卡成功即可计算佣金。",
    "purchaseCommissionTip3": "开卡佣金将在开卡完成后自动结算",
    "purchaseCommissionTip3Desc": "3个工作日之内发放至您的总资产账户。",
    "purchaseCommissionTip3DescPrefix": "",
    "purchaseCommissionTip3Time": "开卡成功，佣金秒结。",
    "purchaseCommissionTip3DescSuffix": "奖励自动发放至您的总资产账户。",
    "purchaseCommissionConfirm": "我知道了",
    "consumptionCommissionTitle": "二级返佣",
    "consumptionCommissionIntro": "您邀请的用户，继续邀请新用户，新用户产生的佣金，您将会获得额外25%的平台奖励。",
    "consumptionCommissionTip1": "消费返佣规则",
    "consumptionCommissionTip1Desc": "例如：A邀请B，B邀请C，C产生25USDT佣金给到B，A将会获得额外6.25USDT平台奖励。",
    "consumptionCommissionTip2": "消费退款规则",
    "consumptionCommissionTip2Desc": "30天内发生退款：该笔消费不产生返佣。",
    "consumptionCommissionTip2Partial": "部分退款",
    "consumptionCommissionTip2PartialDesc": "按实际有效消费金额重新计算返佣。",
    "consumptionCommissionTip3": "已到账返佣发生退款",
    "consumptionCommissionTip3Desc": "已结算返佣对应订单发生退款、撤销或部分退回，用户未提返佣，平台将有权追回已发放返佣。",
    "points": "我的积分",
    "inviteMethod": "邀请方式",
    "invitationCode": "我的邀请码",
    "shareQr": "邀请码二维码",
    "invitationLink": "我的邀请链接",
    "myExclusiveInvite": "我的专属邀请",
    "invitationCodeShort": "邀请码",
    "invitationLinkShort": "邀请链接",
    "invitationRelationTip": "好友使用此邀请码/链接都会和您关联，您将获取该产品的返佣",
    "recommender": "推荐人",
    "enterRecommenderCode": "请输入推荐码",
    "scanRecommenderCode": "扫描推荐码",
    "viewFullRecords": "查看完整记录",
    "personUnit": "人",
    "invitedFriendsTotal": "有效邀请总数",
    "pendingCommission": "待结算返佣",
    "totalCommission": "累计总返佣",
    "parentCode": "邀请人",
    "enterParentCode": "请输入邀请码",
    "bind": "绑定",
    "bound": "已绑定",
    "rewardDetails": "奖励明细",
    "commissionDetails": "返佣明细",
    "recommendedUsers": "推荐用户",
    "tradingFriends": "交易好友",
    "registeredFriends": "注册好友",
    "noRecommendedUsers": "暂无推荐用户",
    "totalCommissionUsdt": "总佣金（USDT）",
    "withdrawable": "可提现",
    "pendingSettlement": "待结算",
    "pendingSettlementTitle": "待结算（USDT）",
    "pendingSettlementDescription": "您将立即看到您的返利，但需要先结算才能领取。如果购买退款，返利也将被撤销。",
    "pendingSettlementQuestion": "我的返利何时结算？",
    "pendingSettlementMonthlyCommission": "团队返佣：半月结算",
    "pendingSettlementCardActivation": "卡激活：成功开卡后，佣金秒结到账",
    "pendingSettlementTransaction": "开卡二级返佣：购买核销后，佣金秒结到账",
    "settled": "已结算",
    "myRewards": "我的奖励",
    "date": "日期",
    "selectDate": "选择日期",
    "rewardSuccess": "成功",
    "rewardReady": "可领取",
    "rewardVoided": "已作废",
    "rewardPartialRefund": "部分退款",
    "rewardRefunded": "已退款",
    "rewardDeducted": "已扣除",
    "rewardDeductionFailed": "扣除失败",
    "rewardCredited": "已到账",
    "rewardCardType": "卡片类型",
    "rewardType": "奖励类型",
    "friendNickname": "好友昵称",
    "invitationRelation": "邀请关系",
    "indirectFriend": "间推好友",
    "rewardAmount": "奖励金额",
    "percentageWeight": "占比权重",
    "deductionAmount": "扣除金额",
    "commissionAllocationRatio": "分配占比",
    "commissionAllocationRatioUnavailable": "暂未提供",
    "commissionSettlementCycle": "结算周期",
    "teamCommissionSettlementCycle": "半月结算",
    "commissionSettlementMethod": "结算方式",
    "commissionInstantSettlement": "秒结到账",
    "commissionTriggerTime": "返佣触发时间",
    "commissionSettlementTime": "返佣结算时间",
    "friendConsumptionRefundTime": "好友消费退款时间",
    "commissionDeductionTime": "返佣扣除时间",
    "commissionStatus": "返佣状态",
    "rewardDetailsAmountPrefix": "奖励明细 ",
    "balanceAfter": "剩余 ",
    "noRewardRecords": "暂无奖励记录",
    "inviteSteps": "邀请步骤",
    "step1": "分享链接或邀请码给您的朋友",
    "step2": "受邀好友通过链接或邀请码完成身份认证和卡片申请",
    "step3": "朋友开通卡片，您将获得返佣奖励"
  },
  "task": {
    "title": "签到赚积分",
    "dailyCheckIn": "每日签到",
    "howToGetPoints": "如何获取积分",
    "myPoints": "我的积分",
    "dailyTasks": "每日任务",
    "checkInTotal": "已经累计签到",
    "days": "天",
    "checkInRules": "签到规则",
    "checkInRuleOne": "1.每日签到，每次展示7天；奖励依次为:5/10/15递增积分，每3天一循环;",
    "checkInRuleTwo": "2.中途漏签，则从5积分开始重新计算奖励。",
    "moreCheckInsMorePoints": "签到越多，积分越多~",
    "checkedInDaysPrefix": "已连续签到",
    "checkedInDaysSuffix": "天",
    "checkedInTodayTomorrow": "今日已签到，明天再来吧~",
    "routineTasks": "日常任务",
    "dailyPointsLimit": "每日获取积分上限1000",
    "basicGrowth": "基础成长",
    "completeSignature": "完善签名",
    "signatureDone": "完成签名",
    "pointsPlusOne": "积分+1",
    "goFollow": "去关注",
    "postMoments": "发朋友圈",
    "perPost": "每发1条",
    "monday": "周一",
    "tuesday": "周二",
    "wednesday": "周三",
    "thursday": "周四",
    "friday": "周五",
    "saturday": "周六",
    "sunday": "周日"
  },
  "card": {
    "title": "卡片",
    "myCards": "我的卡片",
    "openCard": "申请卡片",
    "GoOpenCard": "去开卡",
    "benefits": "卡片权益",
    "bill": "账单",
    "empty": "暂无相关卡片",
    "virtualCard": "虚拟卡",
    "physicalCard": "实体卡",
    "courseCard": "课程卡",
    "courseGiftNoticePhysical": "成功购买实体卡，即可获赠专属线下课程。课程链接将发送至您的注册邮箱，点击即可查看详情及参与方式。",
    "courseGiftNoticeVirtual": "成功购买虚拟卡，即可获赠专属线下课程。课程链接将发送至您的注册邮箱，点击即可查看详情及参与方式。",
    "applyCard": "申请开卡",
    "applyNow": "立即开卡",
    "virtualDesc": "随时随地，线上线下非接触式支付！",
    "physicalDesc": "免年费，无隐藏费用。支持全球ATM取现!",
    "applyCardTypeOne": "申请虚拟卡",
    "applyCardTypeTwo": "申请实体卡",
    "applyCardTip1": "在线申请虚拟卡，支持线上线下支付",
    "applyCardTip2": "实体卡支持邮寄到家，支持ATM取现与POS机消费",
    "applyCardTip3": "线上申领 线下代办实体卡，签收激活即享全部功能",
    "applyCardTip4": "查看并管理虚拟卡与实体卡",
    "kycDialogTitle": "需要身份验证",
    "kycDialogDesc": "请先完成身份验证解锁此功能",
    "kycDialogAction": "立即KYC",
    "useInstruction": "绑卡指南",
    "virtualCardUseInstruction": "虚拟卡使用说明",
    "entityCardUseInstruction": "实体卡使用说明",
    "useInstructionText1": "虚拟卡可绑定支付宝、美团，支持线上消费。",
    "useInstructionText2": "实体卡可绑定支付宝、美团，支持线上线下全场景消费；支持 POS 机刷卡；ATM 取现",
    "useInstructionText3": "为了保障您的资金安全，请不要将卡片信息：如卡号，有效期，cvv码泄露给他人！",
    "useInstructionText4": "解绑卡片后不可恢复使用，一旦确认解绑后不可逆，请谨慎操作！",
    "useInstructionText5": "解绑卡片的开卡费不会退还，但卡内如有剩余金额会退回钱包。",
    "useInstructionText6": "如遇问题可通过“我的-联系我们-在线客服”-联系官方客服处理 !",
    "useInstructionText7": "如何绑定",
    "useInstructionText8": "支付宝",
    "useInstructionText9": "按照以下步骤完成绑卡，操作简单快捷",
    "useInstructionText10": "打开支付宝",
    "useInstructionText11": "进入支付宝 App，点击“我的”",
    "useInstructionText12": "进入银行卡",
    "useInstructionText13": "选择“银行卡”或“支付设置”中的绑卡入口",
    "useInstructionText14": "添加银行卡",
    "useInstructionText15": "点击“添加银行卡”，输入WinPay 卡号",
    "useInstructionText16": "填写卡片信息",
    "useInstructionText17": "按提示填写有效期、CVV码 和验证码等信息",
    "useInstructionText18": "完成验证",
    "useInstructionText19": "提交后完成短信或安全验证，绑卡成功后即可使用",
    "useInstructionText20": "用卡说明",
    "bindCardInfo1": "精选适用场景支持 Alipay 的 Visa 卡，可快速绑定Alipay ,按照以下步骤即可完成绑卡操作",
    "bindCardInfo2": "精选适用场景支持 Google Pay 的 Visa 卡，可快速绑定Google Pay ，按照以下步骤即可完成绑卡操作",
    "bindCardInfo3": "精选适用场景支持Apple Pay的Visa卡,可快速绑定Apple Pay,按照以下步骤即可完成绑卡操作",
    "bindCardInfo4": "下载打开Google Pay，账户登录",
    "bindCardInfo5": "进入Google Pay 首页，点击“添加支付卡”",
    "bindCardInfo6": "添加支付卡",
    "bindCardInfo7": "点击“新增信用卡或借记卡”",
    "bindCardInfo8": "填写个人信息",
    "bindCardInfo9": "填写相关的卡片信息和城市地址等，点击“保存并继续”",
    "bindCardInfo10": "进入发卡机构体条款页面",
    "bindCardInfo11": "滑动至底部，点击“继续”",
    "bindCardInfo12": "选择“验证方式”后,“获取验证码”,填入“验证码校验区”,验证成功后即可完成绑定",
    "bindCardInfo13": "下载打开Apple Pay,账户登录",
    "bindCardInfo14": "进入Apple Pay首页,点击“添加支付卡”",
    "bindCardInfo15": "扫描或者手动输入卡片详细信息",
    "bindCardInfo16": "填写完“卡号、英文姓名、有效期、安全码”等信息",
    "bindCardInfo17": "进入条款与条件页面",
    "bindCardInfo18": "滑动至底部,点击“同意”",
    "coreAdvantages": "核心优势",
    "recommendedAudience": "推荐人群",
    "cardScene": "卡片场景",
    "transferIn": "转入",
    "transferOut": "转出",
    "atmPassword": "ATM密码",
    "cardInfo": "卡片信息",
    "mycard": "我的卡片",
    "benefit": "卡片权益",
    "recentTrade": "账单",
    "viewAll": "查看全部",
    "noTrade": "暂无交易记录",
    "noTradeEmpty": "暂无相关数据",
    "inUse": "使用中",
    "inactive": "未激活",
    "frozen": "冻结中",
    "processing": "处理中",
    "success": "成功",
    "failed": "失败",
    "cardSensitiveTodo": "敏感卡片信息查看流程迁移中",
    "cardWallet": "卡片",
    "cardBenefits": "卡片权益",
    "noBenefit": "暂无权益信息",
    "withdrawMin": "最小提现",
    "withdrawMax": "最大提现",
    "rechargeMin": "最小充值",
    "rechargeMax": "最大充值",
    "monthlyLimit": "月限额",
    "billDetail": "账单明细",
    "feeRate": "支付手续费",
    "chargeFeeLabel": "充值手续费",
    "rechargeFeeLabel": "首充金额",
    "withdrawFeeLabel": "提现手续费",
    "payFeeLabel": "消费手续费",
    "selectCardTemplate": "选择卡片模板",
    "selectScene": "选择使用场景",
    "cardTemplate": "卡片模板",
    "scene": "场景",
    "selectTimeRange": "选择时间范围",
    "timeRangeTip": "切换至“近180天”查看奖励明细",
    "last30Days": "近 30 天",
    "last90Days": "近 90 天",
    "last180Days": "近 180 天",
    "currentScenario": "当前场景",
    "supportedScenes": "适用场景",
    "supportedPlatforms": "适用平台",
    "platformHint": "以发卡方最新支持为准",
    "openCardAmount": "开卡费",
    "openCardAmountTip": "包含开卡费和首充金额",
    "openFeeNoticePrefix": "开卡费",
    "openFeeNoticeSuffix": "充值至卡内，用于保持卡片激活",
    "firstRechargeTip": "开卡需支付 {amount} {symbol}，并额外首充 {charge} {symbol}",
    "cardUsageLimit": "消费限额",
    "monthlyCardUsageLimit": "消费限额/月",
    "cardTitlePrefix": "卡片 ",
    "prepaidCard": "预付卡",
    "identityInfo": "身份信息",
    "identityInfoTip": "实名资料将用于开卡校验",
    "firstName": "名字",
    "lastName": "姓氏",
    "identityInfoEmpty": "请先完成实名资料填写",
    "agreementPrefix": "已阅读并同意",
    "optionalInvitationCode": "请输入邀请码（选填）",
    "openCardNotice": "开卡说明",
    "openCardNotice1": "开卡费用由开卡费和首充金额组成，提交后由系统自动执行。",
    "openCardNotice2": "不同场景支持的平台和费率可能不同，请以发卡结果与渠道规则为准。",
    "openCardNotice3": "若后续需要申请实体卡，请先确保已持有可绑定的虚拟卡。",
    "termsAgree": "我已阅读并同意《用户协议》与《隐私政策》",
    "agreeFirst": "请先勾选协议后再继续",
    "noCardTemplate": "暂无可申请的卡片模板",
    "balanceOverview": "卡片权益总览",
    "monthlyFee": "月费",
    "withdrawNotice": "实体卡最低提现 {amount} {symbol}",
    "applyPhysicalCard": "申请实体卡",
    "physicalApplyDesc": "完成实名后选择模板并填写收货信息，支付后等待制卡配送",
    "shippingFee": "运费",
    "shippingFree": "包邮",
    "applicationFee": "申请费用",
    "applicationFeeLabel": "申请费用：",
    "recentTradeScene": "精选适用场景",
    "physicalSceneDesc": "各类线下线上消费",
    "physicalOrderNotice": "实体卡申请说明",
    "physicalNotice1": "申请实体卡前，请先确保已开通可绑定的虚拟卡。",
    "physicalNotice2": "提交并支付成功后，卡片将进入制作与配送流程。",
    "physicalNotice3": "收到卡片后，请在实体卡激活页完成激活后再使用。",
    "fillShippingInfo": "填写收货信息",
    "requireVirtualCardFirst": "请先开通可绑定的虚拟卡后再申请实体卡",
    "cardInfoTitle": "卡信息",
    "shippingInfoTitle": "收货信息",
    "sameAsVirtualCard": "与虚拟卡一致",
    "receiverName": "姓名",
    "enterReceiverName": "请输入",
    "completeAllInfo": "请完善全部信息",
    "addressMinLength": "详细地址最少 5 个字符",
    "completeShippingAddress": "请完善收货信息，详细地址至少 5 个字符",
    "saveLabel": "保存",
    "confirmOrder": "确认订单信息",
    "payPhysicalCardConfirm": "确认提交实体卡订单并支付吗？",
    "payNow": "立即支付",
    "orderPaid": "支付成功",
    "paymentDetail": "支付详情",
    "paymentFee": "支付的费用",
    "paymentSuccess": "支付成功",
    "paymentSuccessDesc": "您的卡片正在制作中，预计7-14个工作日内送达~",
    "physicalCardMakingTip": "实体卡周期制作较普通卡片稍长，请耐心等待~收到货后，请激活实体卡后使用。",
    "paymentAmount": "支付的费用",
    "physicalArrivalTip1": "实体卡制作周期较普通卡片稍长，请耐心等待。",
    "physicalArrivalTip2": "收到货后，请先激活实体卡，再进行后续使用。",
    "viewPendingCards": "查看未激活卡片",
    "totalAssetsInsufficientBalance": "当前总资产余额不足，请充值后进行后续操作",
    "currentCardInsufficientBalance": "当前卡内资产余额不足，请充值后进行后续操作",
    "topUpNow": "去充值",
    "pendingPhysicalCards": "未激活卡片",
    "pendingActivate": "未激活",
    "noPendingPhysicalCard": "暂无待激活实体卡",
    "hasInactiveCards": "有卡片未激活",
    "physicalInstruction": "实体卡说明",
    "pendingNotice1": "您已成功申请实体卡，当前卡片正在制作或配送中。",
    "pendingNotice2": "为保障账户安全，在签收并完成激活前，实体卡暂时无法使用。",
    "pendingNotice3": "收到卡片后，点击下方按钮即可快速激活。",
    "contactSupport": "联系客服",
    "invitationCode": "邀请码",
    "enterInvitationCode": "请输入邀请码（选填）",
    "openCardConfirm": "确认提交开卡申请吗？",
    "openCardSuccess": "开卡申请已提交",
    "kycTitle": "KYC 认证",
    "kycVerify": "KYC 认证",
    "kycRequirement": "完成 KYC 认证后，才可以继续申请卡片。",
    "kycRequirement1": "请提供真实、准确且与证件一致的信息。",
    "kycRequirement2": "验证结果由服务商审核，可能需要一些时间。",
    "kycIntroTip": "提交真实身份资料后，审核通过即可继续申请虚拟卡。",
    "verifyNow": "立即认证",
    "fillInfo": "填写信息",
    "kycFormTip": "请按证件信息填写常用联系方式与开户地址。",
    "contactAndAddress": "联系方式与地址",
    "countryCode": "区号",
    "selectCountryCode": "请选择区号",
    "phoneNumber": "手机号",
    "enterPhone": "请输入手机号",
    "address": "地址",
    "selectCountry": "请选择国家",
    "selectCountryRegion": "选择国家/地区",
    "searchCountry": "搜索国家",
    "selectRegion": "请选择省/州/地区",
    "selectCity": "请选择城市",
    "enterAddress": "请输入详细地址",
    "postalCode": "邮政编码",
    "enterPostalCode": "请输入邮政编码",
    "completeKycAddress": "请完善地址信息，详细地址至少 5 个字符",
    "kycSubmitted": "信息已提交",
    "kycReview": "信息审核",
    "kycRejected": "KYC 验证被拒绝",
    "kycPending": "信息提交成功待审核",
    "kycApproved": "信息审核通过",
    "kycRejectedTip": "请根据失败原因修改资料后重新提交。",
    "reviewTip": "审核完成后可以选择卡片进行开卡了",
    "reviewDone": "我知道了",
    "cardCanOpen": "可以选择卡片进行开卡了",
    "resubmit": "重新提交",
    "failedReason": "失败原因",
    "activatePending": "有 {count} 张实体卡待激活",
    "oldCardTransferTip": "因 WinPay 升级了虚拟卡与实体卡服务，旧卡暂不支持使用转入 / 转出功能。",
    "oldCardServiceUpgradeNotice": "因 WinPay 升级了虚拟卡与实体卡服务，旧卡暂不支持使用 转入 / 转出功能。 给您带来的不便，敬请谅解。",
    "cardProcessingWait": "卡片处理中，请稍后再试",
    "cardBalance": "卡片余额",
    "accountBalance": "资金账户余额",
    "availableBalanceLabel": "可用余额：",
    "rechargeCurrencyTitle": "充值币种",
    "rechargeAmountTitle": "充值金额",
    "supportedConsumptionScenes": "支持消费场景",
    "keySupportedPlatforms": "重点支持平台",
    "allSupportedPlatforms": "全部支持平台",
    "otherServices": "其他服务",
    "otherPlatforms": "其他服务",
    "cardUsageRules": "用卡规范",
    "usageRule1": "退款率、撤销率、失败率、验证率过高有冻卡风险",
    "usageRule2": "禁止在 Steam、Blizzard、EA、战网、OYSTER LABS 等平台使用",
    "usageRule3": "禁止绑定订阅平台自动扣费",
    "cardSafetyTips": "用卡安全提示",
    "cardSafetyTip1": "请勿将您的卡号、有效期限、CVV 等资料随意告知他人",
    "cardSafetyTip2": "请您合法的使用预付卡，且仅在本卡合规范围内使用",
    "unbindCard": "解绑卡片",
    "unBindCardText_1": "解绑卡片前，请留意卡内余额：",
    "unBindCardText_2": "若卡内存有资金，解绑后余额将自动退回至您的账户资产，退款预计 1-7 个工作日到账。退款明细可到资金流水查询，如有疑问，欢迎联系官方客服咨询。",
    "unBindCardText_3": "解绑后将产生以下影响",
    "unBindCardText_4": "该卡片将无法用户支付和相关交易",
    "unBindCardText_5": "与该卡片绑定的自动扣费服务可能会受到影响",
    "unBindCardText_6": "解绑卡片后将无法重新绑定该卡片",
    "unBindCardText_7": "解绑处理中",
    "unBindCardText_8": "正在解绑卡片...",
    "unBindCardText_9": "请稍等，预计需要两分钟",
    "unBindCardText_10": "为保护您资金安全，解绑后将无法恢复",
    "unBindCardText_11": "解绑成功",
    "unBindCardText_12": "解绑卡片成功",
    "unBindCardText_13": "您的卡片已解绑成功，将不会再卡片列表出现",
    "unBindCardText_14": "解绑失败",
    "unBindCardText_15": "卡片解绑失败",
    "unBindCardText_16": "当前卡片解绑失败，请稍后重新解绑如有疑问，请联系客服处理",
    "unBindCardText_17": "已解绑卡片",
    "unBindCardText_18": "已解绑",
    "unBindCardText_19": "已解绑卡片详情",
    "unBindCardText_20": "解绑卡片时剩余金额：",
    "unBindCardText_21": "剩余金额退款是否成功：",
    "unBindCardText_22": "解绑卡片时间：",
    "unbindCardStatus": "卡片状态",
    "unbindRefundYes": "是",
    "unbindRefundPending": "处理中",
    "minAmount": "最小金额",
    "exchangeRate": "当前价格",
    "chargeArrivalTitle": "充值到账",
    "expectedCardArrival": "预计到账",
    "expectedAccountArrival": "提现到账",
    "submitTransfer": "确认",
    "transferSuccess": "划转成功",
    "transferSuccessTitle": "提示",
    "transferInSuccessDesc": "恭喜您，您已经成功充值",
    "transferOutSuccessDesc": "恭喜您，您已成功提现",
    "enterChargeAmount": "请输入充值金额",
    "enterTransferInAmount": "请输入转入数量",
    "enterTransferOutAmount": "请输入转出数量",
    "enterValidAmount": "请输入正确数量",
    "tradeDetail": "详情",
    "tradeProcessingTip": "交易正在处理中，请稍后查看最终状态",
    "cardNumber": "卡号",
    "tradeType": "交易类型",
    "tradeDescription": "备注",
    "merchant": "商家",
    "amount": "金额",
    "tradeAmount": "交易金额",
    "orderNumber": "订单编号",
    "orderId": "订单号",
    "tradeTime": "时间",
    "noTradeDetail": "暂无交易详情",
    "cvvTip": "CVV 码是卡片背面的 3 位或 4 位数字，用于验证您的身份",
    "sensitiveInfoLocked": "查看卡号、有效期和 CVV 前，需要先验证钱包密码。",
    "sensitiveInfoLockedDesc": "为保障账户安全，敏感卡片信息默认隐藏，验证通过后才会显示。",
    "unlockNow": "验证后查看",
    "myCard": "我的卡片",
    "basicInfo": "卡基本信息",
    "cardType": "卡片类型",
    "cardholder": "持卡人",
    "phoneNumberLabel": "手机号",
    "validThru": "有效期（月/年）",
    "validThroughLabel": "有效期",
    "cvvCode": "CVV 码",
    "openSecurePage": "在新窗口打开安全页",
    "openVerificationPage": "打开验证页面",
    "checkVerificationStatus": "检查验证状态",
    "verificationPageUnavailable": "暂未获取到验证页面，请稍后检查状态",
    "diditSdkTitle": "Didit 人脸认证",
    "sdkIdle": "待启动",
    "sdkLoading": "认证加载中",
    "sdkReady": "认证进行中",
    "sdkUnavailable": "Didit SDK 加载失败，请改用外部打开",
    "sdkCancelled": "KYC 认证已取消",
    "sdkDeclined": "KYC 认证未通过",
    "restartVerification": "重新开始认证",
    "sdkCurrentStep": "当前步骤",
    "sdkLastEvent": "最近事件",
    "sdkStepDocumentSelection": "选择证件类型",
    "sdkStepDocumentFront": "拍摄证件正面",
    "sdkStepDocumentBack": "拍摄证件反面",
    "sdkStepFace": "人脸活体认证",
    "sdkStepEmail": "邮箱验证",
    "cameraPermissionTitle": "开启相机权限",
    "cameraPermissionTip": "后续证件拍摄和人脸识别需要使用浏览器相机，请先授权相机权限。",
    "cameraPermissionDenied": "当前浏览器未获得相机权限，请在浏览器设置中允许相机访问后再继续认证。",
    "cameraPermissionGranted": "浏览器相机权限已准备就绪，可以继续进行证件拍摄和人脸识别。",
    "cameraPermissionGrantedToast": "相机权限已开启",
    "cameraPermissionOpen": "开启权限",
    "cameraPermissionReady": "已开启",
    "cameraPermissionDialog": "当前未获得浏览器相机权限。请在浏览器地址栏或系统设置中允许相机访问后，再继续进行 KYC 认证。",
    "sdkStepPhone": "手机验证",
    "sdkStepPoa": "地址证明",
    "sdkStepQuestionnaire": "问卷信息",
    "sdkEventReady": "认证页已就绪",
    "sdkEventStarted": "已开始认证",
    "sdkEventStepStarted": "步骤开始",
    "sdkEventStepCompleted": "步骤完成",
    "sdkEventStepChanged": "步骤切换",
    "sdkEventMediaStarted": "已开启拍摄",
    "sdkEventMediaCaptured": "已完成拍摄",
    "sdkEventDocumentSelected": "已选择证件",
    "sdkEventSubmitted": "资料已提交",
    "sdkEventCodeSent": "验证码已发送",
    "sdkEventCodeVerified": "验证码已通过",
    "sdkEventStatusUpdated": "认证状态更新",
    "sdkEventCompleted": "认证流程完成",
    "sdkEventCancelled": "认证已取消",
    "sdkEventError": "认证发生错误",
    "sdkEventCloseRequest": "用户请求关闭",
    "kycTokenEmpty": "KYC token 为空，请稍后重试",
    "viewAtmPassword": "查看 ATM 密码",
    "enterAtmPassword": "请输入 6 位 ATM 密码",
    "confirmAtmPassword": "确认ATM密码",
    "atmPasswordTip": "*此密码仅能设置一次，不可修改，设置后支持随时查看。",
    "sixDigitPin": "请输入 6 位纯数字密码",
    "setPinSuccess": "密码设置成功"
  },
  "mine": {
    "title": "我的",
    "mineCode": "我的二维码",
    "scanAddFriend": "扫码添加我的WinPay Wallet好友吧",
    "wallet": "钱包管理",
    "cardCodeRedemption": "卡密核销",
    "enterCardCode": "输入卡密",
    "security": "安全设置",
    "language": "切换语言",
    "selectLanguage": "选择语言",
    "contactUs": "联系我们",
    "about": "关于我们",
    "kyc": "KYC 认证",
    "userId": "我的用户 ID",
    "login": "登录/注册",
    "logout": "登出",
    "logoutConfirm": "确认退出当前账号吗？",
    "logoutConfirmTitle": "确认退出？",
    "logoutConfirmAccount": "确认退出当前账号【{name}】吗？",
    "points": "积分",
    "currentLevel": "当前等级",
    "totalPoints": "总积分",
    "nextLevelPoints": "距下一等级还需 {points} 积分",
    "levelSurpassed": "已超过当前等级",
    "maxLevelReached": "已达到最高等级",
    "exclusiveLevel": "专属等级",
    "dailyCheckInPoints": "每日签到即可获得积分",
    "rewardDetails": "奖励明细",
    "signIn": "签到",
    "signedIn": "已签到",
    "checkInSuccess": "签到成功，奖励 {reward} 积分",
    "gameZone": "游戏区",
    "gameDesc": "轻松赚积分",
    "shopZone": "电商区",
    "shopDesc": "下单送积分",
    "enterZone": "进入",
    "inviteFriends": "邀请好友",
    "inviteDesc": "邀请好友一起使用 WinPay",
    "invitedUsers": "邀请好友注册钱包总数",
    "recommender": "推荐人",
    "bindSuccess": "绑定成功",
    "takePhoto": "拍照",
    "chooseFromAlbum": "从相册选择",
    "avatarUpdated": "头像已更新",
    "avatarUploadFailed": "头像上传失败，请稍后重试",
    "avatarImageOnly": "请选择图片文件",
    "avatarImageTooLarge": "图片不能超过 {size}MB",
    "changeWalletName": "修改钱包名称",
    "enterWalletName": "请输入钱包名称",
    "nameTooLong": "名称不能超过 16 个字符",
    "nameUpdated": "名称已更新",
    "securityTodo": "安全设置迁移中",
    "kycTodo": "去认证",
    "kycPending": "审核中",
    "kycVerified": "已认证",
    "kycFailed": "认证失败",
    "kycTodoDesc": "完成 KYC 认证后，可继续使用虚拟卡和实体卡相关能力。",
    "kycPendingDesc": "认证资料已提交，审核完成后即可继续后续操作。",
    "kycVerifiedDesc": "KYC 认证已完成，当前账户可以正常使用卡片实名认证能力。",
    "kycFailedDesc": "认证资料审核未通过，请根据失败原因重新提交。",
    "viewKycResult": "查看认证结果",
    "retryKyc": "重新认证",
    "aboutDesc": "一站式 Web3 支付钱包",
    "version": "版本",
    "contactDesc": "如有任何问题（例如删除钱包、使用问题等），欢迎通过以下方式联系我们：",
    "supportEmail": "客服信箱",
    "onlineSupport": "在线客服",
    "serviceMailbox": "客户服务邮箱",
    "serviceHours": "客户服务营业时间",
    "weekdayHours": "工作日: 上午09:00 - 下午18:00",
    "supportReplyTip": "本公司客服团队将在营业时间内尽快回复您，协助解决相关问题。",
    "supportThanks": "感谢您的支持与理解。"
  },
  "article": {
    "square": "广场",
    "followTab": "关注",
    "likeTab": "点赞",
    "nowTab": "即时",
    "create": "发布",
    "myArticle": "我的文章",
    "detail": "文章详情",
    "addToken": "添加 Token",
    "addNft": "添加 NFT",
    "reportTitle": "举报",
    "reportSuccess": "感谢您的反馈,将减少类似内容展示",
    "reportFailed": "提交失败，请稍后重试",
    "reasonAttack": "攻击引战",
    "reasonPorn": "色情低俗",
    "reasonDiscomfort": "引人不适",
    "reasonSpam": "垃圾广告",
    "follow": "关注",
    "followed": "已关注",
    "followSuccess": "关注成功",
    "unfollowSuccess": "已取消关注",
    "likeSuccess": "点赞成功",
    "unlikeSuccess": "取消点赞",
    "now": "刚刚",
    "minutesAgo": "分钟前",
    "hoursAgo": "小时前",
    "daysAgo": "天前",
    "views": "浏览",
    "forwarded": "转发",
    "empty": "暂无内容",
    "searchPlaceholder": "搜索",
    "unsupportedNetwork": "当前网络暂不支持访问首页内容",
    "switchNetwork": "切换网络",
    "observerWalletWarn": "观察钱包不能访问首页内容",
    "switchWallet": "切换钱包",
    "openDetailTodo": "文章详情待迁移",
    "createTodo": "发布文章待迁移",
    "addTokenTodo": "添加 Token 功能待迁移",
    "addNftTodo": "添加 NFT 功能待迁移",
    "sampleName": "WinPay 用户",
    "sampleTopic": "Flutter 文章模块迁移预览",
    "sampleContent": "这个页面用于承接文章模块迁移后的 H5 样式、状态和弹窗交互。"
  }
};
